import IFeature from 'models/IFeature'

export interface FeaturesProps {}

export const useFeatures = (props: FeaturesProps) => {
  const features: IFeature[] = [
    {
      title: 'Custom Branding',
      description:
        'Add your own logo, colors, and background to match your restaurant identity.',
      icon: 'brush',
    },
    {
      title: 'Menu Categories',
      description:
        'Create and manage unlimited menu categories and sub-categories.',
      icon: 'grid',
    },
    {
      title: 'Product Management',
      description:
        'Easily add, edit, and remove food items with price and image.',
      icon: 'card-text',
    },
    {
      title: 'Multi-Branch Support',
      description: 'Manage multiple restaurant branches under one account.',
      icon: 'diagram-3',
    },
    {
      title: 'QR Code Ready',
      description: 'Share menus via scannable QR codes for quick access.',
      icon: 'qr-code-scan',
    },
    {
      title: 'Mobile-Friendly UI',
      description: 'Fully responsive design, works perfectly on any device.',
      icon: 'phone',
    },
    {
      title: 'Real-Time Updates',
      description: 'Instantly reflect menu changes with no delay.',
      icon: 'lightning',
    },
    {
      title: 'Restaurant Info',
      description:
        'Display location, contact, Wi-Fi password, and description.',
      icon: 'geo-alt',
    },
    {
      title: 'Opening Hours',
      description:
        'Show your restaurant’s operating hours so customers know when you’re open.',
      icon: 'clock',
    },
    {
      title: 'Custom Sections',
      description:
        'Organize menu by food types: salads, snacks, desserts, etc.',
      icon: 'list-ul',
    },
    {
      title: 'Nutritions Info',
      description:
        'Display nutritions (calories, protein, carbs, fat) for each dish to help health-conscious customers.',
      icon: 'fire',
    },
    {
      title: 'Ingredients List',
      description: 'Show detailed ingredient breakdown for every item.',
      icon: 'list-check',
    },
    {
      title: 'Restaurant Feedback',
      description:
        'Collect customer comments and suggestions to improve service.',
      icon: 'chat-left-text',
    },
    {
      title: 'Experience Rating',
      description:
        'Allow users to rate their dining experience with stars or scores.',
      icon: 'star',
    },
    {
      title: '24/7 Support',
      description:
        'Get round-the-clock assistance whenever you need help with your account.',
      icon: 'headset',
    },
    {
      title: 'AI Menu Assistant',
      description:
        'Let customers chat with AI to explore menu, ingredients, and allergens.',
      icon: 'chat-dots',
      isSoon: true
    },
  ]

  return {
    ...props,
    features,
  }
}
